import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UploadDAO } from '../../../../core/services/dao/uploadDAO';
import { Subscription } from 'rxjs';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { Router } from '@angular/router';
import { User } from 'anchor-shared/lib/model/entity/user';
import { CropperSettings, ImageCropperComponent } from 'ngx-img-cropper';
import { dataURLtoFile } from '../../../../core/pure-functions/upload/image-upload-helper';
import { CometChatDAO } from '../../../../core/services/dao/cometChatDAO';

@Component({
  selector: 'app-profile-photo',
  templateUrl: './profile-photo.component.html',
  styleUrls: ['./profile-photo.component.scss'],
})
export class ProfilePhotoComponent implements OnInit, OnDestroy {
  @Input() title: string;

  @Input() user: User;

  @Input() newUser: boolean;

  @Input() adminAccess: boolean;

  @Output() onCancelled = new EventEmitter<boolean>();
  @Output() onSubmitted = new EventEmitter<any>();

  @ViewChild('cropper')
  cropper: ImageCropperComponent;

  fileToUpload: Blob = null;
  photoUploadedSubscription: Subscription;
  userUpdatedSubscription: Subscription;
  croppedData: any;
  cropperSettings: CropperSettings;
  currentPhotoUrl: string = null;
  showCropper = false;
  maxWidthHeightConstant = 900;
  minWidthHeightConstant = 300;
  canvas = 300;
  subs: Subscription[] = [];

  constructor(
    private uploadDAO: UploadDAO,
    private userDAO: UserDAO,
    private cometChatDAO: CometChatDAO,
    private router: Router,
  ) {
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.width = this.maxWidthHeightConstant;
    this.cropperSettings.height = this.maxWidthHeightConstant;
    this.cropperSettings.croppedWidth = this.minWidthHeightConstant;
    this.cropperSettings.croppedHeight = this.minWidthHeightConstant;
    this.cropperSettings.canvasWidth = this.canvas;
    this.cropperSettings.canvasHeight = this.canvas;
    this.cropperSettings.minWidth = this.minWidthHeightConstant;
    this.cropperSettings.minHeight = this.minWidthHeightConstant;
    this.cropperSettings.noFileInput = true;
    this.cropperSettings.fileType = 'image/jpeg';
    this.croppedData = {};
  }

  ngOnInit() {
    const cacheBuster = Math.floor(Math.random() * Math.floor(1000000));
    this.currentPhotoUrl = this.user.profileAbsPath + '?cache=' + cacheBuster;
    console.log(this.currentPhotoUrl);
  }

  ngOnDestroy(): void {
    if (this.photoUploadedSubscription) {
      this.photoUploadedSubscription.unsubscribe();
    }
    if (this.userUpdatedSubscription) {
      this.userUpdatedSubscription.unsubscribe();
    }
  }

  updatePhoto() {
    const fileName = 'profile_photo_' + this.user.id + '.jpeg';
    this.fileToUpload = this.getCroppedFile(fileName);
    this.photoUploadedSubscription = this.uploadDAO
      .uploadFile(this.fileToUpload, fileName)
      .subscribe((fileResponse: any) => {
        this.user.profileAbsPath = fileResponse.filepath;
        this.user.profileRelPath = fileResponse.relativePath;
        const roleIds = this.user.roles.map((role) => role.id);
        if (this.adminAccess) {
          this.userDAO.adminUpdateUser(this.user, roleIds).subscribe(
            (data) => {
              this.router.navigate(['manage/admin/users']).catch((err) => {
                console.error(err);
              });
            },
            (error) => {
              console.error(error);
            },
          );
        } else {
          this.userUpdatedSubscription = this.userDAO
            .updateFromPartial(this.user.id, {
              profileAbsPath: this.user.profileAbsPath,
              profileRelPath: this.user.profileRelPath,
            })
            .subscribe((userResponse: any) => {
              this.onSubmitted.emit(userResponse);
              this.croppedData.image = null;
            });
          const cometChatUserUpdateSub = this.cometChatDAO
            .updateUserProfileImg(this.user.id, fileResponse.filepath)
            .subscribe();
          this.subs.push(cometChatUserUpdateSub);
        }
        this.showCropper = false;
      });
  }

  getCroppedFile(filename: string): Blob {
    const croppedFileB64 = this.croppedData.image;
    return dataURLtoFile(croppedFileB64, filename);
  }

  handleFileInput($event) {
    this.fileToUpload = $event.target.files[0];
    this.readUrl();
  }

  readUrl() {
    if (this.fileToUpload) {
      const image: any = new Image();
      const reader: FileReader = new FileReader();
      reader.onloadend = (event: any) => {
        console.log('reader.onloadend');
        image.src = event.target.result;
        image.onload = () => {
          console.log('image loaded');
          this.showCropper = true;
          this.cropper.setImage(image);
        };
      };
      reader.readAsDataURL(this.fileToUpload);
    }
  }
}
